import { Button, Paper, Typography } from "@mui/material";
import { FormModal } from "./ModalForForm";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";

export const CommentModal = ({
  openModal,
  setOpenModal,
  comment,
  setComment,
  formDescription,
  handleCommentSubmit,
}) => {
  return (
    <FormModal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      closeAfterTransition
    >
      <Paper className="formModal-class">
        <PageTitle pageName={pageName.general.addComment} />
        <form onSubmit={handleCommentSubmit}>
          <Typography>{formDescription}</Typography>
          <TextFieldWrapper
            multiline
            id="remark"
            name="comment"
            label="Comment/Remark"
            variant="outlined"
            value={comment}
            fullWidth
            required
            onChange={(e) => setComment(e.target.value)}
          />
          <Button variant="contained" type="submit" fullWidth>
            Submit
          </Button>
        </form>
      </Paper>
    </FormModal>
  );
};
